import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Responsive Zoom Scaler
 * Applies a zoom factor to the body based on the current screen width.
 * This runs immediately (before React mounts) and on every window resize,
 * so the dashboard always fits smaller laptop screens without manual browser zoom.
 *
 * Breakpoints:
 *   > 1440px  → 100% (no scaling, full desktop)
 *   1281-1440 → 87%
 *   1025-1280 → 80%
 *   ≤ 1024px  → 75%
 */
function applyResponsiveZoom() {
  const width = window.innerWidth;
  let zoom = 1;

  if (width <= 1024) {
    zoom = 0.75;
  } else if (width <= 1280) {
    zoom = 0.80;
  } else if (width <= 1440) {
    zoom = 0.87;
  } else {
    zoom = 1;
  }

  // Apply zoom directly as an inline style — this always wins over CSS
  document.body.style.zoom = zoom;

  // Adjust the root height to compensate for zoom so scrolling stays correct
  document.getElementById('root').style.minHeight = `${Math.ceil(100 / zoom)}vh`;
}

// Apply on initial load
applyResponsiveZoom();

// Re-apply whenever the window is resized (e.g. docking/undocking a laptop)
window.addEventListener('resize', applyResponsiveZoom);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
